module.exports = __webpack_public_path__ + "img/FPT08.f5f80b9a.svg";